<pmt-action-modal [title]="'shared.newVersion.modalTitle' | transloco" submitButtonIconCode=""
    [submitButtonText]="'shared.newVersion.refresh' | transloco" (submitted)="onSubmit()" class="custom-modal-limiter">
    <div class="alert alert-primary" [innerHTML]="'shared.newVersion.text' | transloco">
    </div>
</pmt-action-modal>